import {
  DEFAULT_SIGNATURE,
  signatureText,
  type Account,
  type SignatureWho,
  type UserSignature,
} from '@procumi/shared';

/** Cine semnează: omul, firma lui și logo-ul public (cum îl vede furnizorul în mail). */
export function whoOf(account: Account): SignatureWho {
  const c = account.company;
  return {
    name: account.user.name,
    email: account.user.email,
    company: c.name,
    logoUrl: c.logoAt ? `${window.location.origin}/api/public/logo/${c.id}?v=${Date.parse(c.logoAt)}` : null,
  };
}

export const mySignature = (account: Account): UserSignature => account.user.signature ?? DEFAULT_SIGNATURE;

/** Semnătura omului ca text: în mailurile deschise în programul de mail și în previzualizări. */
export const mySignatureText = (account: Account): string => signatureText(mySignature(account), whoOf(account));
